import { useState } from "react";
import { Star, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";
import api, { formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";

export const Stars = ({ value = 0, size = "w-4 h-4", onChange }) => (
  <div className="flex gap-0.5" aria-label={`${value} stelle`}>
    {[1, 2, 3, 4, 5].map((n) => {
      const star = <Star aria-hidden="true" className={`${size} ${n <= Math.round(value) ? "fill-[#EAB308] text-[#EAB308]" : "text-stone-300"}`} />;
      return onChange ? (
        <button key={n} type="button" onClick={() => onChange(n)} data-testid={`star-${n}`} aria-label={`${n} stelle`} className="hover:scale-110 transition-transform">{star}</button>
      ) : <span key={n}>{star}</span>;
    })}
  </div>
);

export const ProductReviewDialog = ({ item, existing, onClose, onSaved }) => {
  const [rating, setRating] = useState(existing?.rating || 5);
  const [text, setText] = useState(existing?.text || "");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/products/${item.product_id}/reviews`, { rating, text });
      toast.success(data.discount_code ? `Grazie! Ti abbiamo inviato il codice ${data.discount_code} (-10% sul prossimo ordine)` : "Grazie per la tua recensione!", { duration: 8000 });
      onSaved?.();
      onClose();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="review-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-[#0B2A45]">Valuta {item.name}</DialogTitle>
          <DialogDescription>Scegli da 1 a 5 stelle e racconta la tua esperienza con questo prodotto.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <Stars value={rating} size="w-8 h-8" onChange={setRating} />
          <Textarea value={text} onChange={(e) => setText(e.target.value)} placeholder="Com'è andata? Racconta la tua esperienza (facoltativo)" rows={4} data-testid="review-text-input" />
          <div className="flex justify-end gap-2">
            <Button variant="outline" className="rounded-full" onClick={onClose} data-testid="review-cancel-btn">Annulla</Button>
            <Button className="rounded-full bg-[#0F4C81] text-white" onClick={save} disabled={busy} data-testid="review-submit-btn">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : existing ? "Aggiorna" : "Pubblica"}</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
